import React, { PureComponent } from 'react';
import { METRIC, IMPERIAL } from '../../../lib/types';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { connect } from 'react-redux';
import ProjectSelectors from '../../../reducers/project-reducer';
import ToggleVolumeIconComponent from '../ToggleVolumeIcon';
import { Button } from 'primereact/button';
import PopUpHelper from "../../Calculations/popUpHelper.component";
import { regionIds } from "../../../lib/localization/regionIds";
const cultecLogoBg = require('../../../media/cultec_logo_bg.png');
class ChamberTopCalculationsComponent extends PureComponent {
  render() {
    const {
      lbl,
      unit,
      lang,
      content,
      chamberType,
      systemWidth,
      systemLength,
      storageVolume,
      availableWidth,
      availableLength,
      requiredEndCaps,
      requiredChambers,
      totalStorageProvided,
      rectangularFootprint,
      totalVolume,
      totalLength,
      totalWidth,
      totalArea,
      selectedBed,
      totalChambers,
      totalEndCaps,
      chamberTypeMain, // because of a change, we have to use this as an object, chamberType only shows the name of the chamber
    } = this.props;

    // Create dynamically each label/input
    const renderCalculated = (prop, label, fieldStyle, tutorialClass, unitType, overrideClassName) => {
      return (
        <div
          style={{ fontWeight: 'bold' }}
          className={
            overrideClassName ? overrideClassName : `ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl2 ms-xxl2 ${tutorialClass}`
          }
          compoent-name="renderCalculated">
          {fieldStyle !== null ? (
            <TooltipHost content={fieldStyle.text} directionalHint="bottom">
              <TextField
                key={prop}
                label={label}
                readOnly={true}
                style={fieldStyle.color}
                value={`${unitType === 'string' ? prop : convertUnits(prop, unitType)}`}
              />
            </TooltipHost>
          ) : (
            <TextField
              key={prop}
              label={label}
              readOnly={true}
              value={`${unitType === 'string' ? prop : convertUnits(prop, unitType)}`}
            />
          )}
        </div>
      );
    };

    const convertUnits = (value, unitType) => {
      if (isNaN(value)) console.log('-- value', value, typeof value);

      let unitValue = 0;
      switch (unit) {
        case METRIC:
          switch (unitType) {
            case 'cf': // Cubic feets to cubic meters
              unitValue = parseFloat((Math.round((value / 35.315) * 100) / 100).toString()).toFixed(2);
              break;
            case 'ft': // Feets to meters
              unitValue = parseFloat((Math.round(value * 0.3048 * 100) / 100).toString()).toFixed(2);
              break;
            case 'sf':
              unitValue = parseFloat((Math.round((value / 10.764) * 100) / 100).toString()).toFixed(2);
              break;
            default:
              unitValue = Math.round(value * 100) / 100;
              break;
          }
          break;
        case IMPERIAL:
          // Round all the quantities to show only 2 decimals
          unitValue = Math.round(value * 100) / 100;
          break;
        default:
          break;
      }
      return unitValue;
    };

    /* determining the color of the actual volume */
    let volumeFieldStyle = {};
    let overrideFieldStyle = {};





    /* if less than required volume set it as red */
    if (totalStorageProvided < storageVolume) {
      //If system volume is less than the volume requirement then it is RED = errorColor
      // console.log("%c insuficientVolume ", "color:white; background-color:red;");
      volumeFieldStyle = { color: css.errorColor, text: content[lang].insuficientVolume };
    } else if (
      totalStorageProvided >= storageVolume &&
      totalStorageProvided <= storageVolume + chamberTypeMain.storage * 2
    ) {
      //If the volume requirement is met and the chamber count is less than 2 chambers over the volume requirement, then it is GREEN = okColor
      console.log("%c optimalVolume ", "color:white; background-color:green;");
      volumeFieldStyle = { color: css.okColor, text: content[lang].optimalVolume };
    } else {
      // If the volume requirement is met and is more than 2 chambers over the volume requirement then it is Yellow = warningColor
      console.log("%c exceedingVolume ", "color:white; background-color:orange;");
      volumeFieldStyle = { color: css.warningColor, text: content[lang].exceedingVolume };
    }

    // console.log('chamberTypeMain.storage > ', chamberTypeMain.storage);
    // console.log(`totalStorageProvided > (${totalStorageProvided}), storageVolume > (${storageVolume}), 2chambers > (${chamberTypeMain.storage * 2}) `)
    // console.log(`totalStorageProvided > (${totalStorageProvided}), storageVolume =2C > (${storageVolume + chamberTypeMain.storage * 2})`)

    // change color for override total volume FOR MULTIBED
    function truncateNumber(num, fixed) {
      // I need this to magically align numbers
      let re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
      return Number(num.toString().match(re)[0]);
    }

    // This works on MULTIBED
    if (truncateNumber(totalVolume.toFixed(2), 2) < truncateNumber(this.props.multibedOverallSiteVolume, 2)) {
      overrideFieldStyle = { color: css.errorColor, text: content[lang].insuficientVolume };
    } else if (
      truncateNumber(totalVolume.toFixed(2), 2) >= truncateNumber(this.props.multibedOverallSiteVolume, 2) &&
      truncateNumber(totalVolume.toFixed(2), 2) <= truncateNumber(this.props.multibedOverallSiteVolume, 2)
    ) {
      overrideFieldStyle = { color: css.okColor, text: content[lang].optimalVolume };
    } else {
      overrideFieldStyle = { color: css.warningColor, text: content[lang].exceedingVolume };
    }

    let lengthFieldStyle = {};
    if (systemLength > availableLength) {
      lengthFieldStyle = { color: css.errorColor, text: content[lang].exceedingAvailableLength };
    } else {
      lengthFieldStyle = { color: css.okColor, text: content[lang].belowAvailableLength };
    }

    let widthFieldStyle = {};
    if (systemWidth > availableWidth) {
      widthFieldStyle = { color: css.errorColor, text: content[lang].exceedingAvailableWidth };
    } else {
      widthFieldStyle = { color: css.okColor, text: content[lang].belowAvailableWidth };
    }

    const { isMultiBedProject, hideVolumesComponent, totalBeds } = this.props;

    const isOnOverviewTab = true;
    const overrideClassName = 'ms-Grid-col ms-sm12 ms-md12 ms-lg3 ms-xl3 ms-xxl3 multiBedFixedCalc';
    const normalClassName = 'ms-Grid-col ms-sm12 ms-md12 ms-lg3 ms-xl3 ms-xxl3';
    const showSingleBedTtl = !isMultiBedProject || (isMultiBedProject && !isOnOverviewTab);

    const showInfo = ( title, text, image, chamberImg, type ) => {
      return (
        <PopUpHelper
          text={text}
          title={title}
          image={image}
          type={type}
          chamber={chamberImg}
        />
      );
    };

    let crossSectionPrefix = this.props.lang.substring(0, 2);
    if (
      crossSectionPrefix === "fr" &&
      this.props.region.id === regionIds.europe
    )
      crossSectionPrefix += "FR";

    return (
      <React.Fragment>
        {!hideVolumesComponent && (
          <React.Fragment>
            {showSingleBedTtl && (
              <div
                className="ms-Grid-row"
                component-name="ToggleVolumeContainer-a"
                style={{
                  position: 'fixed',
                  width: '83%',
                  bottom: '76px',
                  textAlign: 'center',
                  color: 'black',
                  backgroundColor: 'transparent',
                }}>
                <div
                  className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4 ms-xxl4 ms-xxxl4"
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                  }}>
                  {showInfo(
                    this.props.chamberTypeMain.name,
                    content[lang][`${this.props.chamberTypeMain.name.replace(/-/g, '')}`],
                    require(`../../../media/chambers/${crossSectionPrefix}/${this.props.chamberTypeMain.id}_CrossSection.png`),
                    require(`../../../media/chambers/${this.props.chamberTypeMain.id}.png`),
                    'crossSectionBtn',
                  )}
                </div>
                <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4 ms-xxl9 ms-xxxl4">
                  <ToggleVolumeIconComponent />
                </div>
                <div
                  className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4 ms-xxl4 ms-xxxl4"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}></div>
              </div>
            )}
            <div
              className="fixTopCalculations fix_top_calculations_bar_single_bed"
              compoent-name="ChamberTopCalculationsComponent single-bed">
              <div className="ms-Grid-row" style={css.padding}>
                {!showSingleBedTtl ? (
                  <React.Fragment>
                    <div className={'ms-Grid-col'}>
                      <div className="selectedBedLabelContainer">
                        <label>{content[lang].totalAllBeds}</label>
                      </div>
                    </div>
                  </React.Fragment>
                ) : null}
                {renderCalculated(
                  showSingleBedTtl ? totalStorageProvided : totalVolume,
                  `${content[lang].volume} (${lbl[unit].cf[lang]})`,
                  showSingleBedTtl ? volumeFieldStyle : overrideFieldStyle,
                  'tutorialVolume',
                  'cf',
                  showSingleBedTtl ? null : normalClassName,
                )}
                {showSingleBedTtl
                  ? renderCalculated(
                      showSingleBedTtl ? systemLength : totalLength,
                      `${content[lang].length} (${lbl[unit].ft[lang]})`,
                      showSingleBedTtl ? lengthFieldStyle : null,
                      'tutorialLength',
                      'ft',
                    )
                  : null}
                {showSingleBedTtl
                  ? renderCalculated(
                      showSingleBedTtl ? systemWidth : totalWidth,
                      `${content[lang].width} (${lbl[unit].ft[lang]})`,
                      showSingleBedTtl ? widthFieldStyle : null,
                      'tutorialWidth',
                      'ft',
                    )
                  : null}
                {renderCalculated(
                  showSingleBedTtl ? rectangularFootprint : totalArea,
                  `${content[lang].area} (${lbl[unit].sf[lang]})`,
                  null,
                  'tutorialArea',
                  'sf',
                  showSingleBedTtl ? null : normalClassName,
                )}
                {showSingleBedTtl
                  ? renderCalculated(
                      showSingleBedTtl ? requiredChambers : totalChambers,
                      content[lang].chambers,
                      null,
                      'tutorialChambers',
                      null,
                    )
                  : null}
                {showSingleBedTtl
                  ? renderCalculated(
                      showSingleBedTtl ? requiredEndCaps : totalEndCaps,
                      content[lang].caps,
                      null,
                      'tutorialCaps',
                      null,
                    )
                  : null}
                {showSingleBedTtl
                  ? null
                  : renderCalculated(
                      totalBeds,
                      content[lang].numberOfBeds,
                      null,
                      'tutorialTotalBeds',
                      null,
                      normalClassName,
                    )}
              </div>
            </div>
          </React.Fragment>
        )}
        {hideVolumesComponent && (
          <div
            className="ms-Grid-row"
            component-name="ToggleVolumeContainer-b"
            style={{
              position: 'fixed',
              width: '83%',
              bottom: '0',
              textAlign: 'center',
              color: 'black',
            }}>
            <div
              className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4 ms-xxl4 ms-xxxl4"
              style={{
                display: 'flex',
                alignItems: 'flex-start',
              }}>
              {showInfo(
                this.props.chamberTypeMain.name,
                content[lang][`${this.props.chamberTypeMain.name.replace(/-/g, '')}`],
                require(`../../../media/chambers/${crossSectionPrefix}/${this.props.chamberTypeMain.id}_CrossSection.png`),
                require(`../../../media/chambers/${this.props.chamberTypeMain.id}.png`),
                'crossSectionBtn',
              )}
            </div>

            <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4 ms-xxl9 ms-xxxl4">
              <ToggleVolumeIconComponent />
            </div>
            <div
              className="ms-Grid-col ms-sm4 ms-md4 ms-lg4 ms-xl4 ms-xxl4 ms-xxxl4"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}></div>
          </div>
        )}
        {/*This is the Overview TAB for MULTIBED*/}
        {isMultiBedProject && isOnOverviewTab && !hideVolumesComponent && (
          <div
            className="fixTopCalculations fix_bottom_calculations_bar"
            compoent-name="ChamberTopCalculationsComponent single-bed">
            <div className="ms-Grid-row multi-bed-selected-calcs ">
              {
                <React.Fragment>
                  <div className={overrideClassName}>
                    <div className="selectedBedLabelContainer">
                      <label className="selectedBedLabel">{this.props.selectedBed.name}</label>
                    </div>
                  </div>
                </React.Fragment>
              }
              {renderCalculated(
                selectedBed.volume,
                `${content[lang].volume} (${lbl[unit].cf[lang]})`,
                volumeFieldStyle,
                'tutorialVolume',
                'cf',
                overrideClassName,
              )}
              {renderCalculated(
                selectedBed.length,
                `${content[lang].length} (${lbl[unit].ft[lang]})`,
                lengthFieldStyle,
                'tutorialLength',
                'ft',
                overrideClassName,
              )}
              {renderCalculated(
                selectedBed.width,
                `${content[lang].width} (${lbl[unit].ft[lang]})`,
                widthFieldStyle,
                'tutorialWidth',
                'ft',
                overrideClassName,
              )}
              {renderCalculated(
                selectedBed.area.toFixed(2),
                `${content[lang].area} (${lbl[unit].sf[lang]})`,
                null,
                'tutorialChamberModel',
                'sf',
                overrideClassName,
              )}
              {renderCalculated(
                selectedBed.chamberTypeName, // chamberType,
                content[lang].chamberModel.substr(0, content[lang].chamberModel.length - 1),
                null,
                'tutorialChamberModel',
                'string',
                overrideClassName,
              )}
              {renderCalculated(
                showSingleBedTtl ? requiredChambers : selectedBed.chambers, //totalChambers,
                content[lang].chambers,
                null,
                'tutorialChambers',
                null,
                overrideClassName,
              )}
              {renderCalculated(
                showSingleBedTtl ? requiredEndCaps : selectedBed.endCaps, // totalEndCaps,
                content[lang].caps,
                null,
                'tutorialCaps',
                null,
                overrideClassName,
              )}
              <div
                className="ms-Grid-row"
                component-name="ToggleVolumeContainer-c"
                style={{ position: 'absolute', width: '100%', margin: '0 auto', marginTop: '10px' }}>
                yy
                <ToggleVolumeIconComponent />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

// Object with styles to avoid create .css files
const css = {
  padding: {
    paddingTop: '5px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '10px',
  },
  errorColor: { //If system volume is less than the volume requirement then it is RED
    boxShadow: '0px 0px 2px 2px red',
  },
  okColor: { //If the volume requirement is met and the chamber count is less than 2 chambers over the volume requirement, then it is GREEN
    boxShadow: '0px 0px 2px 2px green',
  },
  warningColor: { // If the volume requirement is met and is more than 2 chambers over the volume requirement then it is Yellow
    boxShadow: '0px 0px 2px 2px orange',
  },
};

/* the container to component mapping */
const mapStateToProps = (state) => {
  return {
    isMultiBedProject: ProjectSelectors.isMultiBedProject(),
    selectedBed: state.multiBed.selectedBed,
    totalVolume: state.multiBed.totalVolume,
    totalLength: state.multiBed.totalLength,
    totalWidth: state.multiBed.totalWidth,
    totalArea: state.multiBed.totalArea,
    totalChambers: state.multiBed.totalChambers,
    totalEndCaps: state.multiBed.totalEndCaps,
    isOnOverviewTab: state.multiBed.isOnOverviewTab,
    hideVolumesComponent: state.multiBed.hideVolumesComponent,
    multibedIsDirty: state.multiBed.isDirty,
    totalBeds: state.multiBed.beds.length,
    chamberType: state.globals.chamberType.name,
    multibedOverallSiteVolume: state.multiBed.overallSiteVolume,

    chamberTypeMain: state.globals.chamberType,
    lang: state.localization.lang,
    region: state.localization.region,
  };
};

const mapDispatchToProps = {};

/* export this contained component */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChamberTopCalculationsComponent);



// WEBPACK FOOTER //
// ./src/components/LayoutSections/TopCalculations/topCalculations.component.js